import { isEqual } from 'lodash'
import { POST } from '@/api'

const initialGroup = {
  id: null,
  name: null,
  tableIds: [],
  seatJoinFlg: false,
  smokingType: 0,
}
/**
 * 予約受付テーブル
 */
export default {
  namespaced: true,
  state: {
    group: initialGroup,
    busy: false,
  },
  mutations: {
    set(state, group = initialGroup) {
      state.group = group
    },
    busy(state, busy) {
      state.busy = busy
    },
    update(state, group) {
      state.group = { ...state.group, ...group }
    },
  },
  getters: {
    changed({ group }, getters, { reception }) {
      const { id, name, tableIds } = group
      return name && tableIds.length && !(id && isEqual(group, reception.groups.byId[id]))
    },
  },
  actions: {
    async start({ commit, dispatch, state, rootState }, id) {
      if (state.group.id !== id) await dispatch('reception/groups/get', { readonly: true }, { root: true })
      commit('set', id ? rootState.reception.groups.byId[id] : initialGroup)
    },
    async regist(store) {
      const { commit, state } = store

      if (state.busy) return false

      commit('busy', true)

      const { status, message } = await POST('/api/web/reception/group/regist', { ...state.group })

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)

      return status === 200
    },
  },
}
